export function Logo({ onClick, size = "default" }) {
  const sizeConfig = {
    default: { width: 40, height: 40, logoFontSize: 20 },
    small: { width: 28, height: 28, logoFontSize: 14 },
  };

  const config = sizeConfig[size];

  return (
    <div
      onClick={onClick}
      style={{
        cursor: onClick ? "pointer" : "default",
        display: "flex",
        alignItems: "center",
        gap: 10,
      }}
    >
      <div
        style={{
          width: config.width,
          height: config.height,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          filter: "drop-shadow(0 10px 22px rgba(37,99,235,0.28))",
        }}
      >
        <svg viewBox="0 0 64 64" width={config.width} height={config.height} aria-hidden="true">
          <defs>
            <linearGradient id={`hexvault-logo-outline-${size}`} x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#2563eb" />
              <stop offset="100%" stopColor="#2dd4bf" />
            </linearGradient>
            <linearGradient id={`hexvault-logo-core-${size}`} x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#0f172a" />
              <stop offset="100%" stopColor="#111f3a" />
            </linearGradient>
          </defs>
          <path
            d="M32 4 L56 18 L56 46 L32 60 L8 46 L8 18 Z"
            fill={`url(#hexvault-logo-core-${size})`}
            stroke={`url(#hexvault-logo-outline-${size})`}
            strokeWidth="4"
            strokeLinejoin="round"
          />
          <path
            d="M32 16 L44 23 L44 37 L32 44 L20 37 L20 23 Z"
            fill="rgba(37,99,235,0.12)"
            stroke="rgba(191,219,254,0.24)"
            strokeWidth="2"
            strokeLinejoin="round"
          />
          <path
            d="M32 22 C28.6 22 26 24.6 26 28 L26 30 L24 30 C22.9 30 22 30.9 22 32 L22 38 C22 39.1 22.9 40 24 40 L40 40 C41.1 40 42 39.1 42 38 L42 32 C42 30.9 41.1 30 40 30 L38 30 L38 28 C38 24.6 35.4 22 32 22 Z M32 26 C33.1 26 34 26.9 34 28 L34 30 L30 30 L30 28 C30 26.9 30.9 26 32 26 Z"
            fill="#dbeafe"
          />
          <path d="M44 18 L34 28" stroke="#2dd4bf" strokeWidth="3" strokeLinecap="round" />
          <path d="M36 18 H44 V26" stroke="#2dd4bf" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M20 25 L14 29 L14 36 L20 40" stroke="rgba(37,99,235,0.9)" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>
      <span
        style={{
          fontWeight: 800,
          fontSize: config.logoFontSize,
          letterSpacing: "-0.04em",
          color: "#fff",
        }}
      >
        HexVault
      </span>
    </div>
  );
}
